import {
    CLOSE_MODAL,
    OPEN_MODAL,
} from '../actions/types/modal-action-types';
import {
    UPDATE_RECOGNIZED_SENDERS_SUCCESS,
} from '../actions/types/recognized-senders-action-types';
import { POST_DOMAIN_NOTE_SUCCESS } from '../actions/types/domain-notes-action-types';

import { combineReducers } from 'redux';
import { SAVE_DOMAIN_GROUP_SUCCESS } from '../actions/types/domain-groups-action-types';

function type( state = null, action ){
    let newState;

    switch( action.type ){
        case OPEN_MODAL:
            newState = action.modalType;
            break;
        case CLOSE_MODAL:
        case UPDATE_RECOGNIZED_SENDERS_SUCCESS:
        case SAVE_DOMAIN_GROUP_SUCCESS:
        case POST_DOMAIN_NOTE_SUCCESS:
            newState = null;
            break;
        default:
            newState = state;
    }
    return newState;
}

function attributes( state = {}, action ){
    let newState;

    switch( action.type ){
        case OPEN_MODAL:
            newState = { ...action.attributes };
            break;
        case CLOSE_MODAL:
            newState = {};
            break;
        default:
            newState = state;
    }
    return newState;
}

export default combineReducers( {
    attributes,
    type
} );
